(() => {
  function bindNavSelect(root) {
    if (!root || root.dataset.cphNavBound === 'true') return;
    const sel = root.querySelector('[data-cph-nav-select]');
    if (!sel) return;
    root.dataset.cphNavBound = 'true';
    sel.addEventListener('change', () => {
      const url = sel.value;
      if (url) window.location.href = url;
    });
  }

  function initAll() {
    document.querySelectorAll('.collection-page-header').forEach(bindNavSelect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (ev) => {
    const inner = ev.target && ev.target.querySelector ? ev.target.querySelector('.collection-page-header') : null;
    if (inner) bindNavSelect(inner);
  });
})();
